<template>
  <v-container>
    <v-row dense>
      <v-col md="6" sm="12">
        <Welcome />
      </v-col>
      <v-col md="6" sm="12">
        <ExpirationNotifications />
      </v-col>
    </v-row>
    <EuFundLogos />
  </v-container>
</template>

<style scoped>
.greeting {
  color: var(--v-primary-base);
  font-size: large;
  font-weight: bold;
}
</style>

<script>
import Welcome from './Welcome.vue'
import ExpirationNotifications from './ExpirationNotifications.vue'
import EuFundLogos from '@/components/EuFundLogos'

export default {
  components: { Welcome, ExpirationNotifications, EuFundLogos }
}
</script>
